// src/data/developers.js
export const developerNames = [
  '강태경', '고희주', '권규나', '권주연', '권한나',
  '김나연', '김도연', '김도원', '김보민', '김소정',
  '김영서', '김유나', '김은영', '김지현', '노윤지',
  '박소은', '박유진', '박현지', '박효빈', '백수민',
  '안희원', '양서윤', '유예린', '이경미', '이민혜',
  '이현주', '장수현', '장지인', '전다혜', '정보결',
  '정서희', '조영채', '조윤경', '최윤영', '최정인',
  '홍세희', '홍예빈'
];

